import React from "react";
import styled from "styled-components";

import Footer from "../../components/Layout/Footer";
import Header from "../../components/Layout/Header";
import Layout from "../../components/Layout/Layout";
import SlidesLayout from "../../components/ProductSlider";

import OurCommitmentSlide1 from "./OurCommitmentSlide1";
import OurCommitmentSlide2 from "./OurCommitmentSlide2";
import OurCommitmentSlide3 from "./OurCommitmentSlide3";
import OurCommitmentSlide4 from "./OurCommitmentSlide4";
import OurCommitmentSlide5 from "./OurCommitmentSlide5";
import OurCommitmentSlide6 from "./OurCommitmentSlide6";
import OurCommitmentSlide7 from "./OurCommitmentSlide7";

const StyledSlidesLayout = styled(SlidesLayout).attrs({
  width: "7000px",
})`
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
`;
const OurCommitment = () => {
  return (
    <Layout>
      {/*  Header */}
      <Header showBuildMyBed={true} showCart={true} cartIconColor={"#0F475D"} />
      {/*  Body */}
      <StyledSlidesLayout>
        <>
          <OurCommitmentSlide1 />
          <OurCommitmentSlide2 />
          <OurCommitmentSlide3 />
          <OurCommitmentSlide4 />
          <OurCommitmentSlide5 />
          <OurCommitmentSlide6 />
          <OurCommitmentSlide7 />
        </>
      </StyledSlidesLayout>
      {/*  Footer */}
      <Footer showMenuButton={true} styles={{ zIndex: 1100 }}></Footer>
    </Layout>
  );
};

export default OurCommitment;
